<section class="tw-relative">

  <div *ngIf="isBlocking && !isPaid" class="tw-absolute tw-w-full tw-h-full tw-z-50 tw-bg-gradient-to-b tw-from-transparent tw-via-white tw-to-white"></div>
  
  <section class="header !tw-py-0" *ngIf="shouldShowHeader">
    <ng-content select="[head]"></ng-content>
  </section>


  <!-- Con cabecera, el espacio hasta el contenido lo pone la barra (mhFilterBar).
       Sin cabecera, el contenido es lo primero bajo el header y queda a 26 px (10 px de .main_content + tw-pt-page). -->
  <section class="content" [ngClass]="shouldShowHeader ? '!tw-pt-0' : '!tw-pt-page'">
    <ng-content select="[main-content]"></ng-content>
  </section>

</section>
